import LifeChart from './life-chart';

export default LifeChart;
